var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSalary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36 1.009A7 7 0 0115 8l-.009.36A7 7 0 018 15l-.36-.009a7.001 7.001 0 01-6.631-6.63L1 8a7 7 0 017-7l.36.008zM8 2.2a5.8 5.8 0 100 11.6A5.8 5.8 0 008 2.2zM9.019 4.84c.212-.26.6-.316.866-.126s.309.555.096.814l-.715.875.732-.001a.6.6 0 11.004 1.199L8.6 7.604v.8l1.398-.003a.6.6 0 11.004 1.199L8.6 9.604V11a.6.6 0 11-1.2 0V9.608l-1.398.004a.6.6 0 11-.004-1.199L7.4 8.408v-.8l-1.398.004a.6.6 0 11-.004-1.199l.742-.003-.721-.883a.555.555 0 01.096-.814.649.649 0 01.866.126L8 6.083l1.02-1.244z"
  })));
}
export default SvgIconSalary;